import { render, staticRenderFns } from "./b-checkbox.vue?vue&type=template&id=625227d6&"
import script from "./b-checkbox.vue?vue&type=script&lang=js&"
export * from "./b-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports